import { render, staticRenderFns } from "./RuleConfigAdd.vue?vue&type=template&id=1be81e94&scoped=true&"
import script from "./RuleConfigAdd.vue?vue&type=script&lang=js&"
export * from "./RuleConfigAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be81e94",
  null
  
)

export default component.exports